import { UseAthleteOverview } from "@/components/athlete-overview-page/athlete-overview-page-provider";
import { Button, Select, ToggleGroup } from "@digdir/designsystemet-react";
import { DownloadIcon } from "@navikt/aksel-icons";
import { AgeGroup, Gender, SerieType } from "./types";
import clsx from "clsx";

export function AthleteOverviewSerieFilter() {
    const { data, updateSearchParams } = UseAthleteOverview()
    const { searchParams, lowestYear } = data

    const currentYear = new Date().getFullYear();
    const startYear = lowestYear;
    const endYear = currentYear + 1;
    const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => {
        const year = startYear + i;
        return {
            value: year,
            label: `${year - 1}/${year}`
        };
    });
    const handleFilterChange = (newParams: Record<string, any>) => {
        updateSearchParams({ ...newParams, page: 1 });
    };

    const handleDownload = () => {
        const url = data.athleteTable.pdfUrl.class_pdf_urls[0].pdf_url ?? "#"
        window.open(url, "_blank", "noopener,noreferrer");
    }

    return (
        <div className="flex flex-col md:flex-row md:flex-wrap w-full justify-between gap-4 lg:gap-5">
            <div
                className="flex gap-3 lg:gap-10 w-full md:w-fit lg:w-full xl:w-fit flex-col justify-between lg:justify-normal lg:flex-row">
                <div className="flex gap-3 w-full ">
                    <div className="hidden md:block w-[200px]">
                        <ToggleGroup
                            value={searchParams.gender}
                            onChange={value => handleFilterChange({ gender: value as Gender })}
                            className=" rounded border border-neutralNsf"
                        >
                            <ToggleGroup.Item value={Gender.Woman}
                                className={clsx("rounded-[2px] ", searchParams.gender === Gender.Woman && 'bg-brand-accent')}>Kvinner</ToggleGroup.Item>
                            <ToggleGroup.Item value={Gender.Man}
                                className={clsx("rounded-[2px] ", searchParams.gender === Gender.Man && 'bg-brand-accent')}>Menn</ToggleGroup.Item>
                        </ToggleGroup>
                    </div>

                    <Select
                        className="rounded block md:hidden w-full border border-neutralNsf"
                        value={searchParams.gender}
                        onChange={e => handleFilterChange({ gender: e.target.value as Gender })}
                    >
                        <Select.Option value={Gender.Woman}>Kvinner</Select.Option>
                        <Select.Option value={Gender.Man}>Menn</Select.Option>
                    </Select>

                    <Select
                        className="rounded w-full md:w-[200px] border border-neutralNsf"
                        value={searchParams.ageGroup}
                        onChange={e => handleFilterChange({ ageGroup: e.target.value as AgeGroup })}
                    >
                        <Select.Option value={AgeGroup.Senior}>Senior</Select.Option>
                        <Select.Option value={AgeGroup.U23}>U23</Select.Option>
                        <Select.Option value={AgeGroup.Age1920}>19-20</Select.Option>
                        <Select.Option value={AgeGroup.Age18}>18</Select.Option>
                        <Select.Option value={AgeGroup.Age17}>17</Select.Option>
                    </Select>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-fit">
                    <Select
                        className="rounded w-full md:w-[200px] border border-neutralNsf"
                        value={searchParams.year?.toString()}
                        onChange={e => handleFilterChange({ year: parseInt(e.target.value) })}
                    >
                        {years.reverse().map(year => (
                            <Select.Option key={year.value} value={year.value.toString()}>
                                {year.label}
                            </Select.Option>
                        ))}
                    </Select>

                    <Select
                        className="rounded w-full md:w-[200px] border border-neutralNsf"
                        value={searchParams.serieType}
                        onChange={e => handleFilterChange({ serieType: e.target.value })}
                    >
                        <Select.Option value={SerieType.Totalt}>Totalt</Select.Option>
                        <Select.Option value={SerieType.Sprint}>Sprint</Select.Option>
                        <Select.Option value={SerieType.Distanse}>Distanse</Select.Option>
                    </Select>
                </div>
            </div>

            <div className=" w-full md:w-fit lg:w-full xl:w-fit flex justify-end">
                <Button variant={"secondary"} onClick={handleDownload} className={"rounded w-[200px] border border-neutralNsf bg-white"}>
                    Last ned PDF
                    <DownloadIcon />
                </Button>
            </div>
        </div>
    );
}